<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_visits']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :busy="IsBusy"
              >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ ((currentPage - 1) * perPage) + data.index + 1 }}
                </template>
                <template #cell(telephone)="data">
                  0{{ data.item.patient.telephone }}
                </template>
                <template #cell(patient_id)="data">
                  {{ data.item.patient.patient_id }}
                </template>
                <template #cell(name)="data">
                  {{ data.item.patient.name }}
                </template>
                <template #cell(prescription)="data">
                  <b-button @click="view(data.item.patient.patient_id,data.item.visit_id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone)" type="button" class="btn-sm btn" variant="info" :disabled="isRowLoading(data.item.patient.patient_id, 'view')">
                    <b-spinner v-if="isRowLoading(data.item.patient.patient_id, 'view')" small class="align-middle me-1"></b-spinner>
                    <i v-else class="mdi mdi-eye"></i> view
                  </b-button>
                </template>
                <template #cell(status)="data">
                  <span v-if="((data.item.status) == 1)">
                    <b-button @click="pay(data.item.id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone,data.item.patient.patient_id,data.item.visit_id)" type="button" class="btn-sm btn" variant="primary" :disabled="isRowLoading(data.item.patient.patient_id, 'dispense')">
                      <b-spinner v-if="isRowLoading(data.item.patient.patient_id, 'dispense')" small class="align-middle me-1"></b-spinner>
                      <i v-else class="mdi mdi-pill"></i> dispense
                    </b-button>
                  </span>
                  <span v-else class="text-primary">
                    <i class="fas fa-check-circle"></i> |
                    <b-button @click="revert(data.item.id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone,data.item.patient.patient_id,data.item.visit_id)" type="button" class="btn-sm btn" variant="danger" :disabled="isRowLoading(data.item.patient.patient_id, 'return')">
                      <b-spinner v-if="isRowLoading(data.item.patient.patient_id, 'return')" small class="align-middle me-1"></b-spinner>
                      <i v-else class="mdi mdi-undo"></i> Return
                    </b-button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="TotalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients Visits</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="view-medicine" centered title="View Patient Prescriptions" title-class="font-14" hide-footer>
      <h6 class="text-dark">
        Name : <span class="text-primary">{{ name }}</span>
        Gender : <span class="text-primary">{{ gender }}</span>
        Telephone : <span class="text-primary">0{{ telephone }}</span>
      </h6>
      <table class="table table-sm mt-2" style="color: black;" density="compact">
        <thead><tr><th>Medicine</th><th>Unit</th><th>Price</th></tr></thead>
        <tbody>
          <tr v-for="item in prescriptions" :key="item.id">
            <td>{{ item.medicine.name }}</td>
            <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
            <td>{{ item.totalprice }}</td>
          </tr>
        </tbody>
      </table>
      <div class="text-right mt-2">
        <strong>Total Cost: {{ commas(totalCost) }}</strong>
      </div>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-medicine')">Close</b-button>
      </div>
    </b-modal>

    <b-modal id="view-pay" size="lg" centered title="Dispense Medicine" title-class="font-14" hide-footer>
      <div class="dispense-patient-card">
        <div class="dispense-patient-avatar">
          <i class="mdi mdi-account-heart-outline"></i>
        </div>
        <div class="dispense-patient-info">
          <div class="dispense-patient-name">{{ name }}</div>
          <div class="dispense-patient-meta">
            <span class="dispense-patient-meta-item">
              <i class="mdi mdi-gender-male-female"></i>{{ gender }}
            </span>
            <span class="dispense-patient-meta-item">
              <i class="mdi mdi-phone-outline"></i>0{{ telephone }}
            </span>
          </div>
        </div>
      </div>

      <div class="dispense-prescription-list">
        <div
          v-for="item in prescriptions"
          :key="item.id"
          class="dispense-prescription-card"
        >
          <div class="dispense-prescription-header">
            <div class="dispense-prescription-icon">
              <i class="mdi mdi-pill"></i>
            </div>
            <div class="dispense-prescription-titles">
              <div class="dispense-prescription-name">{{ item.medicine.name }}</div>
              <div class="dispense-prescription-sub">
                <span class="dispense-prescription-pill">
                  {{ item.quantity }} {{ item.unit.unit_name }}
                </span>
                <span class="dispense-prescription-price">UGX {{ commas(item.totalprice) }}</span>
              </div>
            </div>
          </div>

          <div v-if="item.allocation_preview" class="dispense-allocation-stack">
            <div
              v-for="allocation in item.allocation_preview.allocations"
              :key="allocation.batch_id"
              class="dispense-allocation-card"
              :class="`dispense-allocation-card--${getAllocationTone(allocation)}`"
            >
              <div class="dispense-allocation-card-top">
                <div class="dispense-allocation-batch">
                  <span class="dispense-allocation-batch-label">Batch</span>
                  <span class="dispense-allocation-batch-number">{{ allocation.batch_number }}</span>
                </div>
                <div class="dispense-allocation-chip" :class="`dispense-allocation-chip--${getAllocationTone(allocation)}`">
                  {{ getAllocationMessage(allocation) }}
                </div>
              </div>
              <div class="dispense-allocation-hero">
                <span class="dispense-allocation-hero-icon">
                  <i class="mdi mdi-arrow-up-bold-circle-outline"></i>
                </span>
                <div class="dispense-allocation-hero-copy">
                  <span class="dispense-allocation-hero-label">Dispensing from this batch</span>
                  <span class="dispense-allocation-hero-value">
                    {{ allocation.quantity_units }}
                    <small>{{ item.unit.unit_name }}</small>
                  </span>
                </div>
              </div>
              <div class="dispense-allocation-metrics">
                <div class="dispense-allocation-metric dispense-allocation-metric--stock">
                  <span class="dispense-allocation-metric-icon">
                    <i class="mdi mdi-archive-outline"></i>
                  </span>
                  <div class="dispense-allocation-metric-copy">
                    <span class="dispense-allocation-metric-label">Remaining after dispense</span>
                    <span class="dispense-allocation-metric-value">
                      {{ formatAllocationUnits(item, allocation.remaining_after_base) }}
                      <small>{{ item.unit.unit_name }}</small>
                    </span>
                  </div>
                </div>
                <div class="dispense-allocation-metric dispense-allocation-metric--expiry">
                  <span class="dispense-allocation-metric-icon">
                    <i class="mdi mdi-calendar-clock-outline"></i>
                  </span>
                  <div class="dispense-allocation-metric-copy">
                    <span class="dispense-allocation-metric-label">Expires</span>
                    <span class="dispense-allocation-metric-value dispense-allocation-metric-value--expiry">
                      {{ formatAllocationExpiry(allocation) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.allocation_preview.warnings && item.allocation_preview.warnings.length" class="dispense-guidance-note">
              <div v-for="(warning, index) in item.allocation_preview.warnings" :key="index">
                {{ friendlyWarningCopy(warning, item) }}
              </div>
            </div>
            <div v-if="shouldShowShortageLine(item)" class="dispense-guidance-note dispense-guidance-note--danger">
              {{ shortageMessage(item) }}
            </div>
          </div>
          <div v-else class="dispense-guidance-note">
            Stock information could not be loaded for this prescription yet. Please refresh the preview and try again.
          </div>
        </div>
      </div>
      <div v-if="dispenseBlockingMessage" class="dispense-guidance-panel">
        <div class="dispense-guidance-panel__header">
          <div class="dispense-guidance-panel__icon">
            <i class="mdi mdi-information-outline"></i>
          </div>
          <div>
            <div class="dispense-guidance-panel__title">Before you dispense</div>
            <div class="dispense-guidance-panel__message">{{ friendlyBlockingMessage }}</div>
          </div>
        </div>
        <div class="dispense-guidance-panel__actions">
          <div
            v-for="(recommendation, index) in dispenseRecommendations"
            :key="`recommendation-${index}`"
            class="dispense-guidance-panel__action"
          >
            <span class="dispense-guidance-panel__bullet"></span>
            <span>{{ recommendation }}</span>
          </div>
        </div>
      </div>
      <form @submit.prevent="addDispense">
        <input v-model="patient_id" type="hidden"/>
        <input v-model="visit_id" type="hidden"/>
        <div class="form-group mb-2">
          <label>Dispense Note</label>
          <textarea v-model="dispensenote" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Dispense Date</label>
          <input v-model="dispensedate" type="date" class="form-control"/>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-pay')" :disabled="isSubmittingDispense">
            Close
          </b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="!canDispenseAll || isSubmittingDispense">
            <b-spinner v-if="isSubmittingDispense" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i> Submit
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="view-revert" centered title="Return Medicine" title-class="font-14" hide-footer>
      <h6 class="text-dark">
        Name: <span class="text-primary">{{ name }}</span>
        Gender: <span class="text-primary">{{ gender }}</span>
        Telephone: <span class="text-primary">0{{ telephone }}</span>
      </h6>
      <table class="table table-sm mt-2" style="color: black;" density="compact">
        <thead>
          <tr>
            <th>Medicine</th>
            <th>Unit</th>
            <th>Price</th>
            <th>Return Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in prescriptions" :key="item.id">
            <td>{{ item.medicine.name }}</td>
            <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
            <td>{{ item.totalprice }}</td>
            <td><input type="number" v-model="item.revert_medicine" class="form-control" :max="item.quantity"></td>
          </tr>
        </tbody>
      </table>
      <form @submit.prevent="addRevert">
        <input v-model="patient_id" type="hidden" />
        <input v-model="visit_id" type="hidden" />
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-revert')" :disabled="isSubmittingReturn">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="isSubmittingReturn">
            <b-spinner v-if="isSubmittingReturn" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i> Submit
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Dispense Medicine",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Dispense Medicine",
      items: [{ text: "Dashboard", to: "/" }, { text: "Dispense Medicine", active: true }],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: "",
      isBusy: true,
      searchDebounce: null,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "patient_id", label: "Patient ID", visible: true },
        { key: "name", label: "Name", visible: true },
        { key: "telephone", label: "Telephone", visible: true },
        { key: "status", label: "Status", visible: true },
        { key: "prescription", label: "Prescription", visible: true },
      ],
      prescriptions: [],
      name: "",
      gender: "",
      telephone: "",
      patient_id: "",
      visit_id: "",
      dispensenote: "",
      dispensedate: new Date().toLocaleDateString("fr-CA"),
      actionLoadingKey: "",
      isSubmittingDispense: false,
      isSubmittingReturn: false,
      dispensemedicines: [],
    };
  },
  computed: {
    Fields() { return this.fields.filter(field => field.visible); },
    Items() { return this.dispensemedicines.map((d) => ({ ...d })); },
    IsBusy() { return this.isBusy; },
    totalCost() {
      return (this.prescriptions || []).reduce((total, item) => total + parseFloat(item.totalprice || 0), 0);
    },
    canDispenseAll() {
      return this.prescriptions.length > 0 && this.prescriptions.every((item) => item.allocation_preview && item.allocation_preview.can_fulfill);
    },
    dispenseBlockingMessage() {
      if (!this.prescriptions.length) {
        return "There are no pending prescriptions left to dispense for this visit.";
      }

      const missingPreview = this.prescriptions.find((item) => !item.allocation_preview);
      if (missingPreview) {
        return `Unable to verify live stock for ${missingPreview.medicine?.name || "one prescription"}.`;
      }

      const insufficientStock = this.prescriptions.find((item) => item.allocation_preview && !item.allocation_preview.can_fulfill);
      if (insufficientStock) {
        const warningMessage = insufficientStock.allocation_preview?.warnings?.[0];
        if (warningMessage) {
          return warningMessage;
        }
        const availableUnits = insufficientStock.allocation_preview?.available_units ?? 0;
        return `${insufficientStock.medicine?.name || "This medicine"} is out of stock for dispensing. Only ${availableUnits} live units are available.`;
      }

      return "";
    },
    friendlyBlockingMessage() {
      if (!this.dispenseBlockingMessage) {
        return "";
      }

      const message = this.dispenseBlockingMessage;
      if (message.toLowerCase().includes("out of stock")) {
        return "This medicine cannot be dispensed right now because there is no live stock available.";
      }
      if (message.toLowerCase().includes("not configured")) {
        return "This prescription needs a valid product item unit setup before dispensing can continue.";
      }
      if (message.toLowerCase().includes("legacy")) {
        return "The system found legacy opening stock, so the batch details need to be confirmed before dispensing.";
      }
      return message;
    },
    dispenseRecommendations() {
      if (!this.prescriptions.length) {
        return [];
      }

      const blockedPrescription = this.prescriptions.find((item) => item.allocation_preview && !item.allocation_preview.can_fulfill);
      if (!blockedPrescription) {
        return [];
      }

      return this.getRecommendationsForPreview(blockedPrescription);
    },
    Medicines() {
      return this.prescriptions.map((item) => ({
        prescription_id: item.id,
      }));
    },
  },
  mounted() {
    this.fetchDispenseMedicine();
  },
  beforeDestroy() {
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
  },
  watch: {
    currentPage() {
      this.fetchDispenseMedicine();
    },
    perPage() {
      this.currentPage = 1;
      this.fetchDispenseMedicine();
    },
    filter() {
      this.currentPage = 1;
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
      this.searchDebounce = setTimeout(() => {
        this.fetchDispenseMedicine();
      }, 300);
    },
  },
  methods: {
    async fetchDispenseMedicine() {
      this.isBusy = true;
      try {
        const response = await axios.get("/dispensemedicine", {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            search: this.filter || "",
          },
        });
        this.dispensemedicines = response.data.prescriptions || [];
        this.TotalRows = response.data.pagination?.total || 0;
      } finally {
        this.isBusy = false;
      }
    },
    commas(x) { return Number(x || 0).toLocaleString(); },
    isRowLoading(patientId, action) {
      return this.actionLoadingKey === `${action}:${patientId}`;
    },
    previewWarnings(item) {
      return item?.allocation_preview?.warnings || [];
    },
    warningContains(item, needle) {
      return this.previewWarnings(item).some((warning) =>
        String(warning || "").toLowerCase().includes(String(needle || "").toLowerCase())
      );
    },
    hasConfigurationWarning(item) {
      return (
        this.warningContains(item, "not configured") ||
        this.warningContains(item, "dispense-enabled") ||
        this.warningContains(item, "not allowed") ||
        this.warningContains(item, "legacy unit mapping")
      );
    },
    hasLegacyOpeningWarning(item) {
      return this.warningContains(item, "legacy opening stock");
    },
    shouldShowShortageLine(item) {
      if (!item?.allocation_preview || item.allocation_preview.can_fulfill) {
        return false;
      }

      if (this.hasConfigurationWarning(item)) {
        return false;
      }

      return !this.warningContains(item, "units of live stock are available");
    },
    shortageMessage(item) {
      const availableUnits = item?.allocation_preview?.available_units ?? 0;
      if (availableUnits <= 0) {
        return "Out of stock right now. Receive a valid batch or confirm whether all available batches are exhausted or expired.";
      }
      return `Only ${availableUnits} live units are available for dispensing right now. Reduce the quantity or add more live stock.`;
    },
    getRecommendationsForPreview(item) {
      if (!item?.allocation_preview) {
        return ["Reload the prescription and try again. If the problem remains, ask an administrator to check the stock preview service."];
      }

      if (this.hasConfigurationWarning(item)) {
        return [
          "Open Product Item Units for this product and enable at least one unit for dispensing.",
          "If this prescription was created with an old unit mapping, recreate the prescription using the configured dispense unit after the product item unit is corrected.",
        ];
      }

      if ((item.allocation_preview.available_units ?? 0) <= 0) {
        return [
          "Check whether all live batches for this product are exhausted or expired.",
          "If a newer valid batch exists, receive or configure it correctly so the system can allocate from it automatically.",
          "If no valid batch exists, add new stock before trying to dispense again.",
        ];
      }

      if (this.hasLegacyOpeningWarning(item)) {
        return [
          "Verify this migrated opening stock against the real physical batch and expiry date.",
          "Receive the actual batch into the system so future dispensing uses verified live stock.",
        ];
      }

      return ["Review the product stock configuration, batch quantities, and expiry dates before retrying the dispense."];
    },
    daysUntilDate(dateValue) {
      if (!dateValue) return null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const target = new Date(dateValue);
      target.setHours(0, 0, 0, 0);
      return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
    },
    formatHumanDate(dateValue) {
      if (!dateValue) return "";
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) {
        return dateValue;
      }
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    formatAllocationUnits(item, baseQuantity) {
      const base = Number(item?.unit?.base_quantity || 1);
      return Math.floor(Number(baseQuantity || 0) / Math.max(1, base));
    },
    getAllocationTone(allocation) {
      const days = this.daysUntilDate(allocation.expiry_date);
      if (allocation.is_legacy_opening) return "legacy";
      if (days === null) return "stable";
      if (days < 0) return "danger";
      if (days <= 10) return "warning";
      return "stable";
    },
    getAllocationMessage(allocation) {
      const days = this.daysUntilDate(allocation.expiry_date);
      if (allocation.is_legacy_opening) return "Legacy stock";
      if (days === null) return "Batch okay";
      if (days < 0) return "Expired";
      if (days === 0) return "Expires today";
      if (days <= 10) return `${days} day${days === 1 ? "" : "s"} left`;
      return "Batch okay";
    },
    formatAllocationExpiry(allocation) {
      const days = this.daysUntilDate(allocation.expiry_date);
      if (allocation.is_legacy_opening && !allocation.expiry_date) {
        return "Legacy opening stock";
      }
      if (!allocation.expiry_date) {
        return "Not recorded";
      }
      if (days !== null && days >= 0 && days <= 10) {
        return `${this.formatHumanDate(allocation.expiry_date)} • ${days} day${days === 1 ? "" : "s"} remaining`;
      }
      if (days !== null && days < 0) {
        return `${this.formatHumanDate(allocation.expiry_date)} • expired`;
      }
      return this.formatHumanDate(allocation.expiry_date);
    },
    friendlyWarningCopy(warning, item) {
      const normalized = String(warning || "").toLowerCase();
      if (normalized.includes("legacy opening stock")) {
        return `This batch is coming from legacy opening stock. Please confirm the real batch and expiry details before the next receive.`;
      }
      if (normalized.includes("not configured")) {
        return `This medicine needs a configured product item unit before it can be dispensed safely.`;
      }
      if (normalized.includes("out of stock")) {
        return this.shortageMessage(item);
      }
      return warning;
    },
    async loadPrescriptions(patientId, visitId, options = {}) {
      const { pendingOnly = false, dispensedOnly = false } = options;
      const formData = new FormData();
      formData.append("patient_id", patientId);
      formData.append("visit_id", visitId);
      const response = await axios.post("/patientprescription", formData);
      let prescriptions = response.data.prescriptions || [];
      if (pendingOnly) {
        prescriptions = prescriptions.filter((item) => Number(item.status) === 1);
      } else if (dispensedOnly) {
        prescriptions = prescriptions.filter((item) => Number(item.status) === 2);
      }
      this.prescriptions = await this.attachDispensePreviews(prescriptions);
    },
    async attachDispensePreviews(prescriptions) {
      if (!prescriptions.length) {
        return [];
      }

      const response = await axios.post("/dispense-allocation-preview", {
        prescription_ids: prescriptions.map((item) => item.id),
      });

      const previews = response.data.previews || {};
      return prescriptions.map((item) => ({
        ...item,
        allocation_preview: previews[item.id]?.allocation ?? item.allocation_preview ?? null,
      }));
    },
    async view(id, visitId, name, gender, telephone) {
      this.actionLoadingKey = `view:${id}`;
      try {
        this.name = name;
        this.gender = gender;
        this.telephone = telephone;
        await this.loadPrescriptions(id, visitId);
        this.$bvModal.show("view-medicine");
      } finally {
        this.actionLoadingKey = "";
      }
    },
    async pay(id, name, gender, telephone, patientId, visitId) {
      this.actionLoadingKey = `dispense:${patientId}`;
      try {
        this.name = name;
        this.gender = gender;
        this.telephone = telephone;
        this.patient_id = patientId;
        this.visit_id = visitId;
        await this.loadPrescriptions(patientId, visitId, { pendingOnly: true });
        if (this.dispenseBlockingMessage) {
          this.$toast.warning(this.friendlyBlockingMessage);
        }
        this.$bvModal.show("view-pay");
      } finally {
        this.actionLoadingKey = "";
      }
    },
    async addDispense() {
      if (!this.canDispenseAll) {
        this.$toast.error(this.friendlyBlockingMessage || "One or more medicines cannot be dispensed because live stock is insufficient.");
        return;
      }
      this.isSubmittingDispense = true;
      try {
        const obj = {
          prescriptions: this.Medicines,
          patient: this.patient_id,
          visit_id: this.visit_id,
          dispense_note: this.dispensenote,
          dispense_date: this.dispensedate
        };
        await axios.post("/adddispenseprescription", obj);
        this.fetchDispenseMedicine();
        this.$bvModal.hide("view-pay");
        this.patient_id = "";
        this.visit_id = "";
        this.dispensenote = "";
        this.prescriptions = [];
        this.$toast.success("Patient prescription dispensed");
      } finally {
        this.isSubmittingDispense = false;
      }
    },
    async revert(id, name, gender, telephone, patientId, visitId) {
      this.actionLoadingKey = `return:${patientId}`;
      try {
        this.name = name;
        this.gender = gender;
        this.telephone = telephone;
        this.patient_id = patientId;
        this.visit_id = visitId;
        await this.loadPrescriptions(patientId, visitId, { dispensedOnly: true });
        this.$bvModal.show("view-revert");
      } finally {
        this.actionLoadingKey = "";
      }
    },
    async addRevert() {
      const items = this.prescriptions
        .filter((item) => Number(item.revert_medicine || 0) > 0)
        .map((item) => ({
          prescription_id: item.id,
          return_quantity: Number(item.revert_medicine),
        }));

      if (!items.length) {
        this.$toast.error("No valid medicines selected for return");
        return;
      }
      this.isSubmittingReturn = true;
      try {
        await axios.post("/revertdispenseprescription", { items });
        this.fetchDispenseMedicine();
        this.$bvModal.hide("view-revert");
        this.prescriptions = [];
        this.$toast.success("Dispensed medicine returned");
      } finally {
        this.isSubmittingReturn = false;
      }
    },
  },
};
</script>

<style scoped>
.dispense-patient-card {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 1rem;
  margin-bottom: 0.85rem;
  border: 1px solid #d1fae5;
  border-radius: 18px;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  box-shadow: 0 8px 22px rgba(16, 185, 129, 0.08);
}

.dispense-patient-avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  font-size: 1.3rem;
  box-shadow: 0 10px 24px rgba(20, 184, 166, 0.28);
}

.dispense-patient-info {
  min-width: 0;
}

.dispense-patient-name {
  font-size: 1.02rem;
  font-weight: 800;
  color: #064e3b;
  line-height: 1.15;
}

.dispense-patient-meta {
  margin-top: 0.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.85rem;
}

.dispense-patient-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #065f46;
}

.dispense-patient-meta-item i {
  font-size: 0.95rem;
  color: #0f766e;
}

.dispense-prescription-list {
  display: grid;
  gap: 0.85rem;
  margin-bottom: 0.85rem;
}

.dispense-prescription-card {
  padding: 0.95rem 1rem;
  border: 1px solid #e4eeea;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.06);
}

.dispense-prescription-header {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px dashed #e4eeea;
}

.dispense-prescription-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  background: linear-gradient(135deg, #ecfeff 0%, #cffafe 100%);
  color: #0e7490;
  font-size: 1.15rem;
}

.dispense-prescription-titles {
  min-width: 0;
  flex: 1;
}

.dispense-prescription-name {
  font-size: 1rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  word-break: break-word;
}

.dispense-prescription-sub {
  margin-top: 0.3rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem 0.6rem;
}

.dispense-prescription-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: #ecfeff;
  color: #0e7490;
  font-size: 0.72rem;
  font-weight: 700;
}

.dispense-prescription-price {
  font-size: 0.85rem;
  font-weight: 800;
  color: #0f766e;
}

.dispense-allocation-stack {
  display: grid;
  gap: 0.55rem;
}

.dispense-allocation-card {
  position: relative;
  padding: 0.78rem 0.85rem 0.78rem 1rem;
  border: 1px solid #dcebe5;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  overflow: hidden;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.dispense-allocation-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 5px;
  border-radius: 18px 0 0 18px;
}

.dispense-allocation-card--stable::before {
  background: linear-gradient(180deg, #22c55e 0%, #16a34a 100%);
}

.dispense-allocation-card--warning::before {
  background: linear-gradient(180deg, #fb923c 0%, #ea580c 100%);
}

.dispense-allocation-card--danger::before {
  background: linear-gradient(180deg, #f87171 0%, #dc2626 100%);
}

.dispense-allocation-card--legacy::before {
  background: linear-gradient(180deg, #a78bfa 0%, #7c3aed 100%);
}

.dispense-allocation-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
}

.dispense-allocation-batch-label {
  display: block;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
}

.dispense-allocation-batch-number {
  display: block;
  margin-top: 0.08rem;
  font-size: 0.95rem;
  font-weight: 800;
  color: #111827;
  line-height: 1.2;
  word-break: break-word;
}

.dispense-allocation-chip {
  flex: 0 0 auto;
  padding: 0.28rem 0.56rem;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 800;
  white-space: nowrap;
}

.dispense-allocation-chip--stable {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #166534;
}

.dispense-allocation-chip--warning {
  background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);
  color: #c2410c;
}

.dispense-allocation-chip--danger {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #b91c1c;
}

.dispense-allocation-chip--legacy {
  background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
  color: #6d28d9;
}

.dispense-allocation-hero {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.7rem 0.85rem;
  margin-top: 0.65rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 1px solid #a7f3d0;
}

.dispense-allocation-hero-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  font-size: 1.15rem;
  background: #ffffff;
  color: #15803d;
  box-shadow: 0 6px 14px rgba(16, 185, 129, 0.18);
}

.dispense-allocation-hero-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.dispense-allocation-hero-label {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #047857;
}

.dispense-allocation-hero-value {
  margin-top: 0.1rem;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.15;
  color: #064e3b;
}

.dispense-allocation-hero-value small {
  margin-left: 0.25rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #065f46;
}

.dispense-allocation-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0.55rem;
}

.dispense-allocation-metric {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.6rem 0.7rem;
  border-radius: 14px;
  border: 1px solid #e4eeea;
  background: #f8fbfa;
  min-width: 0;
}

.dispense-allocation-metric-icon {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  font-size: 0.9rem;
}

.dispense-allocation-metric--stock .dispense-allocation-metric-icon {
  background: #dbeafe;
  color: #1d4ed8;
}

.dispense-allocation-metric--expiry .dispense-allocation-metric-icon {
  background: #ffedd5;
  color: #c2410c;
}

.dispense-allocation-metric-copy {
  min-width: 0;
}

.dispense-allocation-metric-label {
  display: block;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6b7280;
  line-height: 1.3;
}

.dispense-allocation-metric-value {
  display: block;
  margin-top: 0.18rem;
  font-size: 0.86rem;
  font-weight: 700;
  line-height: 1.3;
  color: #1f2937;
  word-break: break-word;
}

.dispense-allocation-metric-value small {
  margin-left: 0.2rem;
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
}

.dispense-allocation-metric-value--expiry {
  font-size: 0.78rem;
}

.dispense-guidance-note {
  padding: 0.65rem 0.75rem;
  border-radius: 14px;
  border: 1px solid #fed7aa;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  color: #9a3412;
  font-size: 0.74rem;
  line-height: 1.4;
}

.dispense-guidance-note--danger {
  border-color: #fecaca;
  background: linear-gradient(135deg, #fff1f2 0%, #fee2e2 100%);
  color: #b91c1c;
}

.dispense-guidance-panel {
  margin-bottom: 0.85rem;
  padding: 0.9rem 1rem;
  border: 1px solid #fde68a;
  border-radius: 18px;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
}

.dispense-guidance-panel__header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.dispense-guidance-panel__icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff7ed;
  color: #c2410c;
  font-size: 1.1rem;
  flex: 0 0 36px;
}

.dispense-guidance-panel__title {
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #92400e;
}

.dispense-guidance-panel__message {
  margin-top: 0.18rem;
  font-size: 0.83rem;
  font-weight: 600;
  line-height: 1.4;
  color: #78350f;
}

.dispense-guidance-panel__actions {
  display: grid;
  gap: 0.45rem;
  margin-top: 0.75rem;
}

.dispense-guidance-panel__action {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.76rem;
  line-height: 1.4;
  color: #7c2d12;
}

.dispense-guidance-panel__bullet {
  width: 8px;
  height: 8px;
  margin-top: 0.33rem;
  border-radius: 999px;
  background: #f59e0b;
  flex: 0 0 8px;
}

@media (max-width: 767px) {
  .dispense-allocation-card-top,
  .dispense-guidance-panel__header,
  .dispense-patient-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .dispense-allocation-chip {
    white-space: normal;
  }

  .dispense-allocation-metrics {
    grid-template-columns: 1fr;
  }
}
</style>
